import React from "react";
import { Container } from "reactstrap";

import Banner from "./Banner";
import Approach from "./Approach";
import About from "./About";
import Portfolio from "./Portfolio";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Contact from "../Contact";

import "./style.css";

const Home = () => (
  <div className="home">
    <Header />
    <main role="main">
      <div class="home--hero">
        <Container>
          <Banner />
        </Container>
      </div>

      <div class="home--approach">
        <Container>
          <Approach />
        </Container>
      </div>

      <div class="home--about">
        <Container>
          <About />
        </Container>
      </div>

      <div class="home--portfolio">
        <Container>
          <Portfolio />
        </Container>
      </div>

      <div class="home--contact">
        <Container>
          <Contact />
        </Container>
      </div>
    </main>
    <Footer />
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js